/**
 * デュエル開始前の応答タブ（Issue #467）。開始位置（start_video_ms）が決まっていない、または動画がそれより前のあいだは、
 * core が開始時にやること（初手 5 枚のドロー・最初の問い合わせ）を画面に出さず、ここで開始位置と先攻を決めさせる。
 * **開始位置と先攻を変えられるのは開始位置が決まっていないときだけ**。決まったあとに動画を戻したときは開始位置へ移動するだけ。
 */
import FirstPlayerPicker from './FirstPlayerPicker';
import { btn } from './RespondTab';
import { fmtTime } from './PlaybackTab';

/** 開始前か: 開始位置が未設定、または動画の位置が開始位置より前。動画が無ければ（開始位置を決められないので）開始前にしない */
export function isBeforeStart({ hasVideo, startMs, videoMs }) {
  if (!hasVideo) return false;
  if (startMs == null) return true;
  return videoMs + 1 < startMs;
}

export default function PreStartPanel({ startMs = null, videoMs = 0, busy = false, hasVideo = false, firstPlayer = 0, players = [], message = null, onSetStart, onSetFirst, onSeekStart, onPlay }) {
  const unset = startMs == null;
  return (
    <div data-testid="prestart-panel" style={{ padding: 14, display: 'flex', flexDirection: 'column', gap: 10, height: '100%', overflowY: 'auto', boxSizing: 'border-box', overscrollBehavior: 'contain' }}>
      <strong style={{ fontSize: 15 }}>デュエル開始前</strong>
      {message ? <div data-testid="prestart-message" style={{ fontSize: 13 }}>{message}</div> : null}
      <div style={{ fontSize: 13, opacity: 0.85 }}>
        {unset
          ? '動画をデュエルが始まる場面（初手を引く前）まで進めて「ここをデュエル開始にする」を押してください。押すまで初手のドローや問い合わせは始まりません。'
          : `動画（${fmtTime(videoMs / 1000)}）がデュエル開始（${fmtTime(startMs / 1000)}）より前です。`}
      </div>
      {unset ? (
        <>
          <FirstPlayerPicker firstPlayer={firstPlayer} players={players} busy={busy} onSetFirst={onSetFirst} />
          <button type="button" data-testid="prestart-set" disabled={busy || !hasVideo} style={btn('primary')} onClick={onSetStart}>ここをデュエル開始にする</button>
        </>
      ) : null}
      <div style={{ display: 'flex', gap: 8 }}>
        {onPlay ? <button type="button" data-testid="prestart-play" disabled={!hasVideo} style={btn('plain', { grow: true })} onClick={onPlay}>▶ 再生して探す</button> : null}
        {!unset ? <button type="button" data-testid="prestart-seek" disabled={!hasVideo} style={btn('plain', { grow: true })} onClick={onSeekStart}>開始位置へ移動</button> : null}
      </div>
    </div>
  );
}
